/* unplugin-vue-components disabled */import { render } from "./standardindexmap.vue?vue&type=template&id=b3ab73fc&scoped=true"
import script from "./standardindexmap.vue?vue&type=script&lang=js"
export * from "./standardindexmap.vue?vue&type=script&lang=js"

import "./standardindexmap.vue?vue&type=style&index=0&id=b3ab73fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ab73fc"]])

export default __exports__